import {
    type CompatibilityListingInput,
    type CompatibilityProfile,
    evaluateListingCompatibility,
    extractAdoptionRequirements,
    selectHardConflictRows,
} from "@wags/matchmaker/pure.ts";

export function getReachOutReviewRows(
    listing: CompatibilityListingInput | undefined,
    profile: CompatibilityProfile,
) {
    if (!listing) return [];
    return selectHardConflictRows(
        evaluateListingCompatibility(listing, profile),
        listing.organizationState,
    );
}

export function contactCompatibilityResult(
    listing: CompatibilityListingInput | undefined,
    hydrated: boolean,
    profile: CompatibilityProfile,
) {
    if (!listing || !hydrated) return null;
    return extractAdoptionRequirements(listing).length > 0
        ? evaluateListingCompatibility(listing, profile)
        : null;
}

export function contactNeedsCompatibilityStep({
    listing,
    hydrated,
    profile,
    reviewProfile,
}: {
    listing: CompatibilityListingInput | undefined;
    hydrated: boolean;
    profile: CompatibilityProfile;
    reviewProfile: CompatibilityProfile | null | undefined;
}) {
    if (!hydrated) return true;
    if (!listing) return false;
    if (reviewProfile === undefined) return true;
    if (
        contactCompatibilityResult(listing, hydrated, profile)?.verdict ===
        "mismatch"
    ) {
        return true;
    }
    return (
        reviewProfile !== null &&
        getReachOutReviewRows(listing, reviewProfile).length > 0
    );
}
